import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {HandlingListComponent} from "./handling-list.component";
import {CtButtonModule, CtFrameworkModule, CtModelModule} from "@ctsolution/ct-framework";
import {LangDownloadFileModule} from "../../lang-download-file/lang-download-file.module";
import {MatIconModule} from "@angular/material/icon";
import {MatLegacyDialogModule as MatDialogModule} from "@angular/material/legacy-dialog";
import {HandlingItemsDialogModule} from "./handling-items-dialog/handling-items-dialog.module";

@NgModule({
  declarations: [
    HandlingListComponent
  ],
  imports: [
    CommonModule,
    CtModelModule,
    LangDownloadFileModule,
    MatIconModule,
    CtFrameworkModule,
    CtButtonModule,
    MatDialogModule,
    HandlingItemsDialogModule
  ]
})
export class HandlingListModule {
}
